import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ForgotPasswordModel,
  LoginModel,
  SetUpPasswordModel,
  SignUpModel,
  Token,
  VerifyEmailModel,
} from '@app/auth/models';
import { SetIsAuthenticated } from '@app/auth/store';
import { ResetProfile } from '@app/profile/store';
import { APP_CONFIG, AppConfig } from '@core/models';
import { CookieStorageService, HttpService } from '@core/services';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpService,
    private cookieStorageService: CookieStorageService,
    private router: Router,
    private store: Store,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {}

  login(payload: LoginModel): Observable<Token> {
    const { clientId } = this.config;

    return this.http.post('/public/account/login', { ...payload, clientId });
  }

  refreshToken(refreshToken: string): Observable<Token> {
    const { clientId } = this.config;

    return this.http.post('/public/account/refresh', { refreshToken, clientId });
  }

  forgotPassword(payload: ForgotPasswordModel): Observable<void> {
    return this.http.post('/public/account/forgotpassword', payload);
  }

  signUp(payload: SignUpModel): Observable<Token> {
    const { clientId } = this.config;

    return this.http.post('/public/account', { ...payload, clientId });
  }

  setUpPassword(payload: SetUpPasswordModel): Observable<void> {
    return this.http.post('/public/account/resetpassword', payload);
  }

  verifyEmail(payload: VerifyEmailModel): Observable<void> {
    return this.http.post('/public/account/confirmEmail', payload);
  }

  applyCoach(): Observable<Token> {
    return this.http.post('/public/Roles/add/coach');
  }

  applyReferee(): Observable<Token> {
    return this.http.post('/public/Roles/add/referee');
  }

  applyPlayer(): Observable<Token> {
    return this.http.post('/public/Roles/add/player');
  }

  logout(): void {
    this.cookieStorageService.set('token', '', new Date(0));
    this.cookieStorageService.set('refresh-token', '', new Date(0));
    this.router.navigate(['login']);
    this.store.dispatch(new SetIsAuthenticated(false));
    this.store.dispatch(new ResetProfile());
  }
}
